import {
  FluentProvider,
  Image,
  teamsDarkTheme,
  makeStyles,
  Field,
  ProgressBar,
  tokens,
  teamsHighContrastTheme,
  teamsLightTheme,
  useTimeout,
  mergeClasses
} from '@fluentui/react-components';
import { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles({
  container: {
    height: '100%',
    width: '100%',
    background: tokens.colorNeutralBackground2,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    transition: 'opacity 1s ease-in',
  },
  loadingImage: {
    background: `radial-gradient(ellipse closest-side,rgba(0, 213, 255, 0.2), ${tokens.colorNeutralBackground2})`,
    backgroundRepeat: 'no-repeat',
    animationIterationCount: 'infinite',
    animationDuration: '10s',
    animationDirection: 'alternate',
    animationName: {
      from: {
        backgroundSize: '50% 50%',
        backgroundPosition: '50% 50%'
      },
      to: {
        backgroundSize: '100% 100%',
        backgroundPosition: '0% 0%'
      }
    }
  },
  loadingBar: {
    width: '100%',
  },
  hidden: {
    opacity: 0,
  },
  shown: {
    opactiy: 1
  }
});
export const StartupLoadingScreen = () => {
  const classes = useStyles();
  const theme = useMemo(() => {
    const isHighContrast = window.matchMedia(
      '(forced-colors: active)'
    ).matches;
    if (isHighContrast) {
      return teamsHighContrastTheme;
    }
    const isDarkMode = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    return isDarkMode ? teamsDarkTheme : teamsLightTheme;
  }, []);

  const [showLoadingScreen, setShowLoadingScreen] = useState(false);
  const [setTimeout, clearTimeout] = useTimeout();

  useEffect(() => {
    setTimeout(() => {
      setShowLoadingScreen(true);
    }, 2_000);
    return () => {
      clearTimeout();
    };
  }, [setTimeout, clearTimeout]);

  const contentClass = mergeClasses(classes.content, showLoadingScreen ? classes.shown : classes.hidden);
  return (
    <FluentProvider theme={theme}>
      <div className={classes.container}>
        <div className={contentClass}>
          <div className={classes.loadingImage}>
            <Image src={'/images/startup/logo.png'} alt="Developer Portal" width={256} height={256} />
            <Field validationState="none" className={classes.loadingBar}>
              <ProgressBar />
            </Field>
          </div>
        </div>

      </div>
    </FluentProvider>
  );
};
